var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfodarkgrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.13425 0 0 3.13425 0 7C0 10.8657 3.13425 14 7 14C10.8657 14 14 10.8657 14 7C14 3.13425 10.8657 0 7 0ZM5.81408 9.33917C6.14308 8.29558 6.76608 7.0455 6.87633 6.72933C7.03558 6.27025 6.75325 6.06667 5.86133 6.85125L5.663 6.47792C6.68033 5.37133 8.77508 5.12108 8.06225 6.8355C7.61717 7.90592 7.29867 8.62867 7.11667 9.18633C6.85125 9.99892 7.5215 9.66933 8.17775 9.06325C8.267 9.20908 8.29617 9.25633 8.38542 9.42433C6.92825 10.8115 5.31067 10.934 5.81408 9.33917ZM8.58025 4.57392C8.26992 4.83817 7.81025 4.83233 7.553 4.56108C7.29575 4.28983 7.33892 3.85642 7.64867 3.59217C7.959 3.32792 8.41867 3.33433 8.67592 3.605C8.932 3.87683 8.89 4.31025 8.58025 4.57392Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfodarkgrey);
export default __webpack_public_path__ + "static/media/info.dark.grey.58780557186a5dd995ae881996990623.svg";
export { ForwardRef as ReactComponent };